export default __webpack_public_path__ + "static/media/ppt.9336364f.svg";